/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  DeleteApiV1AccesscontrolPermissionsBatch202,
  DeleteApiV1AccesscontrolPermissionsBatch400,
  DeleteApiV1AccesscontrolPermissionsBatch401,
  DeleteApiV1AccesscontrolPermissionsBatch500,
  DeleteApiV1AccesscontrolPermissionsBatchMutationResponse,
  DeleteApiV1AccesscontrolPermissionsBatchQueryParams,
} from "../../types/accessControlPermissionsController/DeleteApiV1AccesscontrolPermissionsBatch.ts";

export const deleteApiV1AccesscontrolPermissionsBatchQueryParamsSchema = z
  .object({
    roleId: z.optional(z.coerce.number().int()),
    controllerId: z.optional(z.coerce.number().int()),
  })
  .optional() as unknown as ToZod<DeleteApiV1AccesscontrolPermissionsBatchQueryParams>;

/**
 * @description (Accepted) Requisição aceita.
 */
export const deleteApiV1AccesscontrolPermissionsBatch202Schema =
  z.any() as unknown as ToZod<DeleteApiV1AccesscontrolPermissionsBatch202>;

/**
 * @description (Bad Request) Requisição em formato incorreto ou com dados faltantes.
 */
export const deleteApiV1AccesscontrolPermissionsBatch400Schema =
  z.any() as unknown as ToZod<DeleteApiV1AccesscontrolPermissionsBatch400>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const deleteApiV1AccesscontrolPermissionsBatch401Schema =
  z.any() as unknown as ToZod<DeleteApiV1AccesscontrolPermissionsBatch401>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const deleteApiV1AccesscontrolPermissionsBatch500Schema =
  z.any() as unknown as ToZod<DeleteApiV1AccesscontrolPermissionsBatch500>;

export const deleteApiV1AccesscontrolPermissionsBatchMutationResponseSchema =
  z.lazy(
    () => deleteApiV1AccesscontrolPermissionsBatch202Schema,
  ) as unknown as ToZod<DeleteApiV1AccesscontrolPermissionsBatchMutationResponse>;
